import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { ErrorPage } from 'common';
import { fetchForbiddenErrorPage } from './ForbiddenErrorPageSlice';
import { ForbiddenErrorPageContentSelector } from './ForbiddenErrorPageContentSelector';

export function useForbiddenErrorPage(): AbstractContentState<ErrorPage> {
    return useCmsContent(fetchForbiddenErrorPage, ForbiddenErrorPageContentSelector);
}
